import { useState, useEffect } from 'react';
import { BXPGreetingsTable } from 'components/tables/BXPGreetingsTable';
import {
  fetchBXPGreetings,
  BXPGreeting
} from 'services/hvaservicecampaign.service';

const BXPGreetingList: React.FC = () => {
  const [greetings, setGreetings] = useState<BXPGreeting[]>([]);
  const loadGreetings = async (): Promise<void> => {
    try {
      const fetchedGreetings = await fetchBXPGreetings();
      setGreetings(fetchedGreetings);
    } catch (error) {
      console.error('Error loading greetings:', error);
    }
  };

  useEffect(() => {
    loadGreetings();
  }, []);

  return (
    <div>
      <div className="mb-2">
        <BXPGreetingsTable
          greetings={greetings}
          onGreetingsChange={loadGreetings}
        />
      </div>
    </div>
  );
};

export default BXPGreetingList;
